import React from 'react';
import { useRouter } from 'next/router';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useMediaQuery } from '@mantine/hooks';

const TabbedCards = (props: any) => {
  const router = useRouter();
  const {
    children,
    onSetTab,
    styleType,
    tabClassNames,
    tabChildrenClassNames,
    containerClassNames,
    extendTabUnderline,
  } = props;
  const tabs = React.Children.toArray(children);
  const pathname = router.asPath;
  const onlyOneTab =
    tabs.filter((tab: any) => tab.props.isShowing).length === 1;
  const isMobile = useMediaQuery('(max-width: 640px)');

  return (
    <div className="flex flex-col h-full">
      <div
        className={classNames(
          'overflow-x-scroll md:overflow-x-visible',
          containerClassNames,
          {
            'md:mr-0': isMobile,
            'mr-auto': !isMobile && !extendTabUnderline,
          },
        )}
      >
        <div
          className={classNames(
            'flex flex-row border-b border-solid border-gray-300 w-full overflow-x-scroll md:overflow-x-visible',
            tabClassNames,
            { 'md:px-20 px-5': styleType === 'round' },
          )}
        >
          {tabs.map((tab: any, idx) => {
            const selected = !!pathname.match(`/${tab.props.path}`);

            if (!tab.props.isShowing || onlyOneTab) {
              return null;
            }

            let url = pathname.split('/').slice(0, -1).join('/');
            if (tab.props.absolutePath) {
              url = tab.props.absolutePath;
            }
            return React.cloneElement(tab, {
              key: tab.props.name,
              url,
              onSetTab,
              selected,
              styleType,
            });
          })}
        </div>
      </div>
      <div className={classNames('h-full', tabChildrenClassNames)}>
        {tabs.map((tab: any) => {
          if (!tab.props.isShowing) return null;
          const selected = !!pathname.match(`/${tab.props.path}`);

          if (!tab.props.isShowing || !selected) {
            return null;
          }

          return tab.props.children;
        })}
      </div>
    </div>
  );
};

TabbedCards.propTypes = {
  // children: PropTypes.oneOfType([
  // 	PropTypes.arrayOf(Tab),
  // 	Tab
  // ]).isRequired,
  fallbackPath: PropTypes.string,
  tabClassNames: PropTypes.string,
  children: PropTypes.node,
  onSetTab: PropTypes.func,
  styleType: PropTypes.oneOf(['block', 'round']),
  tabChildrenClassNames: PropTypes.string,
  containerClassNames: PropTypes.string,
  extendTabUnderline: PropTypes.bool,
};

TabbedCards.defaultProps = {
  onSetTab: null,
  styleType: 'round',
  extendTabUnderline: false,
};

export default TabbedCards;
